module.exports = __webpack_public_path__ + "media/images/emblems/Oetwil_am_See-blazon-a72218fb54fd1a9130ffb18f49d0fb91.svg";